import dayjs from "dayjs";

export function formatColumns(columns: any) {
    return columns?.map((column: any) => {
        if (column?.type === "decimal") {
            return {
                ...column,
                renderCell: (params: any) => {
                    return (
                        <div>
                            {
                                params.value != null
                                    ? `${parseFloat(params.value).toLocaleString("tr-TR", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    })} ${params.row.currency}`
                                    : ""
                            }
                        </div>
                    );
                },
            };
        } else if (column?.type === "decimalOnly") {
            return {
                ...column,
                renderCell: (params: any) => (
                    <div>
                        {
                            params.value != null
                                ? parseFloat(params.value).toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })
                                : ""
                        }
                    </div>
                ),
            };
        } else if (column?.type === "decimalPercentage") {
            return {
                ...column,
                renderCell: (params: any) => (
                    <div>
                        {
                            params.value != null
                                ? `${parseFloat(params.value).toLocaleString("tr-TR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })} %`
                                : ""
                        }
                    </div>
                ),
            };
        } else if (column?.type == "datetime") {
            return {
                ...column,
                renderCell: (params: any) => {
                    if (!params.value) return "";
                    const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm:ss");
                    if (formattedDate === "Invalid Date") return "";
                    return <div>{formattedDate} </div>;
                }
            }
        }
        return column;
    });
}
